/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_GuideInputs */

const en_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide`)
};

const es_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía`)
};

const fr_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide`)
};

const de_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfaden`)
};

const ja_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイド`)
};

const zh_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指南`)
};

const ar_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دليل`)
};

const id_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan`)
};

const it_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida`)
};

const ru_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гайд/Справочник`)
};

const pt_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia`)
};

const ko_val_guide = /** @type {(inputs: Val_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가이드`)
};

/**
* | output |
* | --- |
* | "Guide" |
*
* @param {Val_GuideInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_guide = /** @type {((inputs?: Val_GuideInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_GuideInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_guide(inputs)
	if (locale === "es") return es_val_guide(inputs)
	if (locale === "fr") return fr_val_guide(inputs)
	if (locale === "de") return de_val_guide(inputs)
	if (locale === "ja") return ja_val_guide(inputs)
	if (locale === "zh") return zh_val_guide(inputs)
	if (locale === "ar") return ar_val_guide(inputs)
	if (locale === "id") return id_val_guide(inputs)
	if (locale === "it") return it_val_guide(inputs)
	if (locale === "ru") return ru_val_guide(inputs)
	if (locale === "pt") return pt_val_guide(inputs)
	return ko_val_guide(inputs)
});